(function () {
  'use strict';
  if (window.SCCCardCartControls) { window.SCCCardCartControls.refresh(); return; }
  let forms = [];
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const groups = new Map();
  const quantities = new Map();
  const availability = new Map();
  const stocks = new Map();
  const stockRequests = new Map();
  const messageTimers = new WeakMap();
  let cartReadVersion = 0;
  let cartChanging = false;
  function registerForms() {
    forms = Array.from(document.querySelectorAll('.scc-custom-card .scc-parts-cart-form'));
    groups.clear();
    forms.forEach(function (form) {
      const handle = form.dataset.productHandle;
      if (!groups.has(handle)) groups.set(handle, []);
      groups.get(handle).push(form);
      form.action = root + 'cart/add';
      if (!availability.has(form.dataset.variantId)) availability.set(form.dataset.variantId, !form.querySelector('.scc-parts-cart-button').disabled);
      if (!stocks.has(form.dataset.variantId)) {
        stocks.set(form.dataset.variantId, {full: form.dataset.canAddMore === 'false', checkedAt: 0});
      }
      applyControls(form);
    });
  }
  registerForms();
  window.SCCCardCartControls = {refresh: function () { registerForms(); syncCartQuantities(); }};
  new MutationObserver(function (records) {
    const changed = records.some(function (record) { return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) { return node.nodeType === 1 && (node.matches('.scc-parts-cart-form') || node.querySelector('.scc-parts-cart-form')); }); });
    if (changed) { registerForms(); syncCartQuantities(); }
  }).observe(document.body, {childList: true, subtree: true});
  function applyControls(form) {
    const id = form.dataset.variantId;
    const stock = stocks.get(id);
    const inCart = quantities.get(id) || 0;
    const full = stock && stock.full;
    const available = availability.get(id);
    const busy = cartChanging || form.dataset.busy === 'true';
    const button = form.querySelector('.scc-parts-cart-button');
    const input = form.elements.namedItem('quantity');
    button.disabled = busy || !available || !!full;
    input.disabled = button.disabled;
    const remove = form.querySelector('.scc-card-remove');
    if (remove) { remove.hidden = inCart === 0; remove.disabled = busy || inCart === 0; }
    input.closest('.scc-quantity-control').querySelectorAll('button').forEach(function (arrow) {
      const reducesCart = arrow.dataset.quantityStep === 'down' && inCart > 1;
      arrow.disabled = busy || (reducesCart ? false : button.disabled);
      arrow.title = reducesCart ? 'Remove one package from your cart' : '';
    });
    button.textContent = busy ? (form.dataset.removing === 'true' ? 'Removing…' : 'Adding…') : available ? (form.dataset.buttonLabel || 'Buy') : 'Sold Out';
    button.title = full && inCart > 0 ? 'All available stock is already in your cart.' : '';
  }
  function showMessage(form, message, success) {
    window.clearTimeout(messageTimers.get(form));
    const status = form.querySelector('.scc-parts-cart-status');
    status.textContent = message;
    messageTimers.set(form, window.setTimeout(function () { showCartLink(form); }, 3000));
  }
  function showCartLink(form) {
    const status = form.querySelector('.scc-parts-cart-status');
    status.textContent = '';
    if (!(quantities.get(form.dataset.variantId) > 0)) return;
    const link = document.createElement('a');
    link.href = root + 'cart'; link.textContent = 'View Cart';
    link.style.color = '#ffcc00'; link.style.textDecoration = 'underline';
    link.addEventListener('click', function (event) { event.preventDefault(); event.stopImmediatePropagation(); window.location.assign(link.href); });
    status.appendChild(link);
  }
  async function removeFromCart(form) {
    if (cartChanging) return;
    window.clearTimeout(messageTimers.get(form));
    form.querySelector('.scc-parts-cart-status').textContent = '';
    form.dataset.removing = 'true';
    cartChanging = true; forms.forEach(applyControls);
    try {
      const read = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!read.ok) throw new Error('Unable to read your cart. Please try again.');
      const cart = await read.json();
      const updates = {};
      (cart.items || []).filter(function (item) { return String(item.variant_id) === form.dataset.variantId; }).forEach(function (item) { updates[item.key] = 0; });
      if (Object.keys(updates).length) {
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({updates: updates})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to remove this car.');
        cartReadVersion++; showCartQuantities(result);
      } else { cartReadVersion++; showCartQuantities(cart); }
      form.elements.namedItem('quantity').value = '1';
      showMessage(form, 'Removed from cart.', true);
    } catch (error) { showMessage(form, error.message || 'Unable to remove this car. Please try again.', false); }
    finally {
      await syncCartQuantities();
      await loadStock(form.dataset.productHandle, true);
      form.dataset.removing = 'false'; cartChanging = false; forms.forEach(applyControls);
    }
  }
  async function reduceCart(form) {
    if (cartChanging) return;
    cartChanging = true; forms.forEach(applyControls);
    try {
      const read = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!read.ok) throw new Error('Unable to read your cart. Please try again.');
      const cart = await read.json();
      const items = (cart.items || []).filter(function (item) { return String(item.variant_id) === form.dataset.variantId; });
      const total = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      if (total <= 1) { cartReadVersion++; showCartQuantities(cart); return; }
      const item = items.find(function (line) { return line.quantity > 0; });
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: item.key, quantity: item.quantity - 1})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to reduce this quantity.');
      cartReadVersion++; showCartQuantities(result);
      showMessage(form, 'Cart quantity reduced to ' + (total - 1) + '.', true);
    } catch (error) { showMessage(form, error.message || 'Unable to update your cart.', false); }
    finally { await syncCartQuantities(); cartChanging = false; forms.forEach(applyControls); }
  }
  async function loadStock(handle, force) {
    const group = groups.get(handle);
    const fresh = group.every(function (form) { const stock = stocks.get(form.dataset.variantId); return stock && stock.cartQuantity === (quantities.get(form.dataset.variantId) || 0) && Date.now() - stock.checkedAt < 15000; });
    if (!force && fresh) return;
    if (stockRequests.has(handle)) return stockRequests.get(handle);
    const requestedQuantities = new Map(group.map(function (form) { return [form.dataset.variantId, quantities.get(form.dataset.variantId) || 0]; }));
    const request = (async function () {
      try {
        const response = await fetch(group[0].dataset.cartStateUrl || (root + 'products/' + encodeURIComponent(handle) + '?view=scc-card-cart-state'), {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) return;
        const productStock = await response.json();
        if (!Array.isArray(productStock.variants)) return;
        group.forEach(function (form) {
          const id = form.dataset.variantId;
          const variant = productStock.variants.find(function (item) { return String(item.id) === id; });
          if (!variant || typeof variant.can_add_more !== 'boolean') return;
          if (requestedQuantities.get(id) !== (quantities.get(id) || 0)) return;
          stocks.set(id, {full: !variant.can_add_more, cartQuantity: requestedQuantities.get(id), checkedAt: Date.now()});
          availability.set(id, variant.available === true);
          applyControls(form);
        });
      } catch (error) { /* Shopify remains the final inventory authority if a stock read fails. */ }
    })();
    stockRequests.set(handle, request);
    try { await request; } finally { stockRequests.delete(handle); }
    if (group.some(function (form) { return requestedQuantities.get(form.dataset.variantId) !== (quantities.get(form.dataset.variantId) || 0); })) await loadStock(handle, false);
  }
  function showCartQuantities(cart) {
    const previousQuantities = new Map(quantities);
    quantities.clear();
    (cart.items || []).forEach(function (item) {
      const id = String(item.variant_id);
      quantities.set(id, (quantities.get(id) || 0) + item.quantity);
    });
    const checkHandles = new Set();
    forms.forEach(function (form) {
      const cue = form.querySelector('.scc-parts-in-cart');
      const count = quantities.get(form.dataset.variantId) || 0;
      cue.hidden = count === 0;
      cue.textContent = count ? '✓ In cart: ' + count : '';
      applyControls(form);
      const status = form.querySelector('.scc-parts-cart-status');
      if ((count && !status.textContent) || (!count && status.querySelector('a'))) showCartLink(form);
      const stock = stocks.get(form.dataset.variantId);
      if (count || (previousQuantities.get(form.dataset.variantId) || 0) !== count || (stock && (stock.full || (stock.cartQuantity != null && stock.cartQuantity !== count)))) checkHandles.add(form.dataset.productHandle);
    });
    const stockUpdates = Array.from(checkHandles, function (handle) { return loadStock(handle, false); });
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count], .cart-info a[href$="/cart"] em').forEach(function (node) { node.textContent = cart.item_count; });
    document.querySelectorAll('.cart-count-bubble').forEach(function (node) { node.style.display = cart.item_count ? '' : 'none'; });
    return Promise.all(stockUpdates);
  }
  async function syncCartQuantities() {
    const version = ++cartReadVersion;
    try {
      const response = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (version === cartReadVersion) await showCartQuantities(cart);
    } catch (error) { /* Retain the last confirmed cart cue during a temporary network failure. */ }
  }
  async function refresh(handle) {
    try {
      const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) return;
      const product = await response.json();
      groups.get(handle).forEach(function (form) {
        const variant = product.variants.find(function (v) { return String(v.id) === form.dataset.variantId; });
        availability.set(form.dataset.variantId, !!(variant && variant.available));
        applyControls(form);
      });
    } catch (error) { /* Preserve the last confirmed product availability. */ }
  }
  let next = 0;
  const handles = Array.from(groups.keys());
  async function worker() { while (next < handles.length) await refresh(handles[next++]); }
  for (let i = 0; i < 5; i++) worker();
  document.addEventListener('scc:cart-updated', function (event) {
    if (event.detail && event.detail.cart) { cartReadVersion++; showCartQuantities(event.detail.cart); }
    else syncCartQuantities();
  });
  window.addEventListener('pageshow', syncCartQuantities);
  window.addEventListener('focus', syncCartQuantities);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) syncCartQuantities(); });
  window.setInterval(function () { if (!document.hidden) syncCartQuantities(); }, 15000);
  syncCartQuantities();
  document.addEventListener('click', function (event) {
    const remove = event.target.closest('.scc-card-remove');
    if (remove) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!remove.disabled) removeFromCart(remove.closest('.scc-parts-cart-form'));
      return;
    }
    const arrow = event.target.closest('[data-quantity-step]');
    if (!arrow || arrow.disabled) return;
    const input = arrow.closest('.scc-quantity-control').querySelector('input');
    const form = input.form;
    if (form && arrow.dataset.quantityStep === 'down' && (quantities.get(form.dataset.variantId) || 0) > 1) {
      event.preventDefault(); event.stopImmediatePropagation(); reduceCart(form); return;
    }
    if (input.disabled) return;
    if (!input.value || !input.checkValidity()) input.value = '1';
    if (arrow.dataset.quantityStep === 'up') input.stepUp(); else input.stepDown();
    if (form) applyControls(form);
  }, true);
  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('.scc-parts-cart-form');
    if (!form) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (cartChanging || form.dataset.busy === 'true' || form.querySelector('.scc-parts-cart-button').disabled) return;
    const input = form.elements.namedItem('quantity');
    const quantity = Number(input.value);
    if (!input.checkValidity() || !Number.isSafeInteger(quantity) || quantity < 1) {
      showMessage(form, 'Please enter a whole-number quantity of 1 or more.', false); input.reportValidity(); return;
    }
    window.clearTimeout(messageTimers.get(form));
    form.querySelector('.scc-parts-cart-status').textContent = '';
    form.dataset.busy = 'true'; cartChanging = true; forms.forEach(applyControls);
    try {
      await loadStock(form.dataset.productHandle, true);
      const stock = stocks.get(form.dataset.variantId);
      if (stock && stock.full) {
        showMessage(form, availability.get(form.dataset.variantId) ? 'All available stock is already in your cart.' : 'This car is currently sold out.', false);
      } else {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: Number(form.dataset.variantId), quantity: quantity}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this car.');
        showMessage(form, quantity + (quantity === 1 ? ' package added to cart.' : ' packages added to cart.'), true);
      }
    } catch (error) {
      showMessage(form, error.message || 'Unable to add this car. Please try again.', false);
    } finally {
      // An inventory error can still add the remaining stock, so always reread the actual cart.
      await syncCartQuantities();
      input.value = '1';
      form.dataset.busy = 'false'; cartChanging = false; forms.forEach(applyControls);
      refresh(form.dataset.productHandle);
    }
  }, true);
})();
